import axios from 'axios'

export const api = axios.create({
  baseURL: 'https://api.mueadaat.com/api/v1/admin',
  headers: {
    'Content-Type': 'application/json',
    authorization: localStorage.getItem('token'),
  },
})
